/* eslint-env es2020 */

const FALLBACK_AVATAR = "https://cdn.discordapp.com/embed/avatars/0.png";

export function getDefaultAvatarIndex(userId) {
  try {
    return Number((BigInt(userId) >> 22n) % 6n);
  } catch {
    return 0;
  }
}

export function getDiscordAvatarUrl(user) {
  if (!user) return FALLBACK_AVATAR;

  if (user.avatar?.startsWith("http")) {
    return user.avatar.includes("/null.") ? FALLBACK_AVATAR : user.avatar;
  }

  if (user.id && user.avatar) {
    const ext = user.avatar.startsWith("a_") ? "gif" : "png";
    return `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.${ext}?size=128`;
  }

  if (user.id) {
    return `https://cdn.discordapp.com/embed/avatars/${getDefaultAvatarIndex(user.id)}.png`;
  }

  return FALLBACK_AVATAR;
}
